<template>
  <el-dialog :title="$t('COMMON_DELETE')"
             visible
             width="40%"
             @close="onCancel">

    <div class="wl-title">{{$t('SITE_APPROVAL_DESC')}}</div>

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="120px"
             class="demo-ruleForm">
      <el-form-item :label="$t('SITE_APPROVER')"
                    prop="approver">
        <el-input v-model="ruleForm.approver"
                  maxlength="50"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="wl-grey">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 @click="onConfirm"
                 class="wl-green">{{$t('btn_save')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            ruleForm: {
                approver: ''
            }
        }
    },
    computed: {
        rules() {
            const rules = {
                approver: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }]
            }
            return rules
        }
    },
    methods: {
        onConfirm() {
            this.$refs.ruleForm.validate(validate => {
                if (validate) {
                    this.onDelete(this.ruleForm)
                }
            })
        }
    },
    props: {
        onDelete: Function,
        onCancel: Function
    }
}
</script>
<style scoped>
.wl-m-select {
    width: 100%;
}
.wl-title {
    height: 48px;
}
</style>
